var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticsExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 146,
    viewBox: "0 0 153 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 133,
    transform: "matrix(1 0 0 -1 102 133)",
    fill: "#0000C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 133,
    transform: "matrix(1 0 0 -1 102 133)",
    fill: "url(#paint0_linear_3906_377174)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 97,
    transform: "matrix(1 0 0 -1 51 133)",
    fill: "#0000C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 97,
    transform: "matrix(1 0 0 -1 51 133)",
    fill: "url(#paint1_linear_3906_377174)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 62,
    transform: "matrix(1 0 0 -1 0 133)",
    fill: "#0000C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 62,
    transform: "matrix(1 0 0 -1 0 133)",
    fill: "url(#paint2_linear_3906_377174)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2418 99.3009C35.3466 97.4778 37.72 96.8956 39.543 98.0004V98.0004C41.3661 99.1051 41.9483 101.479 40.8435 103.302L16.9687 142.698C15.8639 144.521 13.4904 145.104 11.6674 143.999V143.999C9.84441 142.894 9.26216 140.521 10.3669 138.698L34.2418 99.3009Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 62,
    r: 41.5,
    stroke: "#14E6E6",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63.5L51.5 79.5L80 48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3906_377174",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3906_377174",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3906_377174",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsExport);
export default __webpack_public_path__ + "static/media/statisticsExport.6900c34ceab26b27bd389f2a6fd4ca2d.svg";
export { ForwardRef as ReactComponent };